import { useState } from "react";
import RegionToggleButton from "./RegionToggleButton";
import { useQuery } from "convex/react";
import { api } from "#convex/_generated/api.js";
import { Doc, Id } from "#convex/_generated/dataModel.js";
import AgencyAccountToggleButton from "./AgencyAccountToggleButton";

export default function AgencyAccountLabel({ agencyaccount, region, user }: { agencyaccount: Doc<"AgencyAccount">, region: Id<"Region">, user: Doc<"User">}) {
  const [currentAgencyName, setCurrentAgencyName] = useState<string>(agencyaccount.name)
  const regions = useQuery(api.region.getRegions, { ids: agencyaccount.regions.map((q: string) => q) })
  const agencies = useQuery(api.agencyAccount.getAdminAgencyAccounts, { userId: user._id })
  return (
      <div className="mb-8 bg-blue rounded-lg text-white">
        {agencies && agencies.length > 1 ? 
          <AgencyAccountToggleButton agencies={agencies} agency={agencyaccount._id} /> : 
          <p className="p-3">{currentAgencyName}</p>
        }
        {regions && regions.length > 0 && <RegionToggleButton regions={regions.sort((a, b) => a.name.localeCompare(b.name))} region={region} />}
      </div>
  )
}